<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01">
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryName"><a href="#/chapter1#ch01">Next Door</a></p></div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryName"><a href="#/chapter2#ch02">Hunters in the Snow</a></p></div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryName"><span href="#/chapter3#ch03" title="Link target outside of Sample">An Episode in the Life of Professor Brooke</span></p></div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryName"><span href="#/chapter4#ch04" title="Link target outside of Sample">Smokers</span></p></div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryName"><span href="#/chapter5#ch05" title="Link target outside of Sample">Face to Face</span></p></div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryName"><span href="#/chapter6#ch06" title="Link target outside of Sample">Passengers</span></p></div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryName"><span href="#/chapter7#ch07" title="Link target outside of Sample">Maiden Voyage</span></p></div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryName"><span href="#/chapter8#ch08" title="Link target outside of Sample">Worldly Goods</span></p></div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryName"><span href="#/chapter9#ch09" title="Link target outside of Sample">Wingfield</span></p></div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryName"><span href="#/chapter10#ch10" title="Link target outside of Sample">In the Garden of the North American Martyrs</span></p></div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryName"><span href="#/chapter11#ch11" title="Link target outside of Sample">Poaching</span></p></div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryName"><span href="#/chapter12#ch12" title="Link target outside of Sample">The Liar</span></p></div>
<div class="contentsEntry" id="ata_01">
<p class="contentsEntryName"><span href="#/abouttheauthor#ata01" title="Link target outside of Sample">About the Author</span></p></div>
<div class="contentsEntry" id="rev_01">
<p class="contentsEntryName"><span href="#/praise#rev01" title="Link target outside of Sample">Praise</span></p></div>
<div class="contentsEntry" id="adc_01">
<p class="contentsEntryName"><span href="#/alsobytobiaswolff#adc01" title="Link target outside of Sample">Other Books by Tobias Wolff</span></p></div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/copyright#cop01" title="Link target outside of Sample">Copyright</span></p></div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/aboutthepublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?397ddf46